import { render, staticRenderFns } from "./up-pwd.vue?vue&type=template&id=7cd310b5&scoped=true&"
import script from "./up-pwd.vue?vue&type=script&lang=js&"
export * from "./up-pwd.vue?vue&type=script&lang=js&"
import style0 from "./up-pwd.vue?vue&type=style&index=0&id=7cd310b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd310b5",
  null
  
)

export default component.exports